import { LanguageNotAvailable } from './LanguageNotAvailable';
import { HelmetAndMetaData } from './HelmetAndMetaData';
import IContent from '@episerver/spa-core/dist/Models/IContent';
import { useEpiserver } from '@episerver/spa-core';
import { getPageTypeAsString } from '../Utils';

type DefaultPageContainerProps = {
    children: React.ReactNode;
    iContent: IContent;
    heading: string;
    className?: string;
};

export const DefaultPageContainer = ({ children, iContent, heading, className = '' }: DefaultPageContainerProps) => {
    const context = useEpiserver();
    const pageLanguage = iContent.language.name !== context.Language ? iContent.language.name : null;
    const pageClassName = 'container page-container breadcrumb-margin ' + className;
    const pageKey = getPageTypeAsString(iContent) + '-container';

    return (
        <>
            <div className={pageClassName} key={pageKey} lang={pageLanguage}>
                <HelmetAndMetaData iContent={iContent} heading={heading} context={context} />
                <LanguageNotAvailable iContent={iContent} />
                {children}
            </div>
        </>
    );
};

export default DefaultPageContainer;
